module.exports = __webpack_public_path__ + "img/premium.642f8e1e.png";